import React from "react"
import classNames from "classnames"
import { PaymentStatus } from "../ordersType"
import { useTranslation } from "react-i18next"

export const PaymentState = ({
  payment,
  className,
}: {
  payment: PaymentStatus
  className?: string
}) => {
  const { t } = useTranslation()

  return (
    <span
      className={classNames(
        payment === PaymentStatus.paid
          ? "text-primary bg-primary-30"
          : payment === PaymentStatus.pendingPayment
          ? "text-warning bg-warning-30"
          : payment === PaymentStatus.unpaid
          ? "text-danger bg-danger-30"
          : "text-primary bg-primary-30",
        "py-1 px-2 rounded fw-bold font-size-12",
        className
      )}
    >
      {t(payment)}
    </span>
  )
}
